import { appeler } from './callable';

/**
 * Le jeton qui ouvre une carte Apple, delivre par le serveur.
 *
 * La cle qui le signe ne quitte pas le serveur (voir `functions/src/carte.ts`).
 * Le jeton vit trente minutes : MapKit en redemande un de lui-meme quand
 * il expire.
 */
export async function jetonDeCarte(): Promise<string> {
  const { jeton } = await appeler<Record<string, never>, { jeton: string }>('jetonDeCarte', {});
  return jeton;
}
